import { render, staticRenderFns } from "./about_us.middle.vue?vue&type=template&id=531644c8&scoped=true"
import script from "./about_us.middle.vue?vue&type=script&lang=js"
export * from "./about_us.middle.vue?vue&type=script&lang=js"
import style0 from "./about_us.middle.vue?vue&type=style&index=0&id=531644c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.nvm/versions/node/v22.19.0/lib/node_modules/@vue/cli-service-global/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531644c8",
  null
  
)

export default component.exports